var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M711.38,483.64c0,.15-150.62.26-336.36.26s-336.4-.11-336.4-.26,150.58-.26,336.4-.26S711.38,483.5,711.38,483.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-4--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.11,367.45c.49-2.41.15-4.91.7-9.45s2.7-6.35,3.9-9.57,2.82-10.73,2.82-10.73h-1.31s-4.28,14-5.51,17.14-1.19,6-1.41,8.91a63.16,63.16,0,0,1-1.36,7.67s-1.58-16.2-2.23-21.88-.36-16.76-.36-16.76l-1.5-.64v8.39s.62,8,1.12,12.6a280.43,280.43,0,0,1,1.38,30.42A70.72,70.72,0,0,0,601,403.89c0,.35.46,11.15.24,16.51s-.34,26.54-.12,27.48l4.77,1.14s-2.77-18.68-2.25-32.19-.62-12.76-2.4-19.22-1.21-24-1.21-24A45.17,45.17,0,0,0,602.11,367.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.6,339.45a24.69,24.69,0,0,0,11.16-7.5c4.33-5.5,7.16-10,11.66-12.16-8.66-3.83-14,3.83-18.33,6.16s-8.66,4-8,8.5S607.6,339.45,607.6,339.45Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.46,271.19a42.41,42.41,0,0,1-1.54,4.88,55.71,55.71,0,0,1-2.68,6,37.33,37.33,0,0,1-3.54,5.59,14.46,14.46,0,0,1-4.27,3.9,7.44,7.44,0,0,1-1,.45,65,65,0,0,0-11,4.66,19.85,19.85,0,0,1-2.36-12.08,17.55,17.55,0,0,1,1.17-4.18,24.8,24.8,0,0,1,1.88-3.63c.36-.6.7-1.14,1-1.6s.59-1,.91-1.48a34.3,34.3,0,0,1,6.18-7.41c.54-.48,1.12-1,1.73-1.43a11.1,11.1,0,0,1,2.37-1.37,26,26,0,0,1,9.79-1.63s1,1.17,1.83,5.17a2,2,0,0,1,0,.26A12.59,12.59,0,0,1,635.46,271.19Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.09,310.46s12-8.16,27.15-6.66c-8.16-8-14.82-7.66-20.49-4.83S614.59,304,617.09,310.46Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.27,297.47S597.44,290,589.44,288a71.44,71.44,0,0,0-17.15-1.67s4.49-6.49,14.32-6,12.83,3,14.49,6.33S604.6,293.64,603.27,297.47Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.1,321.79c0,1-.06,2-.13,2.92-.35,4.94-1.49,8.35-5.7,8.91a13.11,13.11,0,0,1-8.33-7.33c-2.33-5.83-1-6.83-4.49-10.66s-5.33-13.33-5.33-13.33h0a19.91,19.91,0,0,1,12.29,1.17l.28.14C596.77,306.56,602.27,315.39,602.1,321.79Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.28,339.28s-1,1.33-7.16,1.83-7.67,5.5-14.66,6.66-8,1-11-.83c1.35-4.21,4.74-5.47,7.82-7.89a14.08,14.08,0,0,0,2.7-2.7,3.79,3.79,0,0,0,.3-.4,10.68,10.68,0,0,1,5.73-3.77h0a19.73,19.73,0,0,1,5.49-.82,15.27,15.27,0,0,1,6.26,1.09C586.11,334.45,586.11,337,586.28,339.28Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.93,456.64A72.3,72.3,0,0,1,613.24,480a5.28,5.28,0,0,1-4.83,3.16h-9.54A5.27,5.27,0,0,1,594,480a72,72,0,0,1-5.69-23.31,96.8,96.8,0,0,1-.3-9.7h31.18A96.8,96.8,0,0,1,618.93,456.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.3,456.64a74.07,74.07,0,0,1-5.83,23.88,5.41,5.41,0,0,1-5,3.24h-9.77a5.42,5.42,0,0,1-5-3.24A73.8,73.8,0,0,1,588,456.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.82,409.29a17.63,17.63,0,0,0-13.23-5.58l-.13.12c-1,5,1.3,10.38,5.17,13.74a22.43,22.43,0,0,0,14.23,5A23.39,23.39,0,0,0,621.82,409.29Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.1,414.51a11.84,11.84,0,0,0-6,.73,33,33,0,0,0-12.28,7.49c4.13,1.43,8.45,2.74,12.78,2.26s8.72-3.22,9.8-7.44C596,415.54,594.1,414.9,592.1,414.51Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,388.52a8.9,8.9,0,0,0,4.26,3.37,54.21,54.21,0,0,1,5.08,2.17c2.88,1.62,4.95,4.36,7.64,6.29a16.41,16.41,0,0,0,13.37,2.52,15.67,15.67,0,0,0-4-12.92,18.2,18.2,0,0,0-12.44-5.65,21.7,21.7,0,0,0-13.19,3.91",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.53,393.81c-1.68-4.11,0-9.61,3.22-12.65,2.12-2,4.91-3.07,7.64-4.07q3.4-1.24,6.86-2.41a2.27,2.27,0,0,1,1.67-.13c.78.37.88,1.41.83,2.27a21.92,21.92,0,0,1-2.8,9.95,14.85,14.85,0,0,1-7.78,6.62c-3.29,1.14-6.78,2.4-9.64.42",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.47,378.41a6.82,6.82,0,0,0-3.4-4.93,13.48,13.48,0,0,0-5.91-1.67A26.78,26.78,0,0,0,569,374.59a47.7,47.7,0,0,0,12.8,6.16,14.4,14.4,0,0,0,5.83.84,6.16,6.16,0,0,0,4.83-3",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.46,356.63a29.36,29.36,0,0,0-11.6-3.5c.54,4.26,1.45,8.78,4.47,11.84a10.85,10.85,0,0,0,6.85,3.17,12.14,12.14,0,0,0,7.71-2v-.21A15.55,15.55,0,0,0,592.46,356.63Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.22,347.9c-2.2,1.46-2.38,4.8-1.1,7.1s3.6,3.82,5.82,5.23a64,64,0,0,0,9,5.06C632,367,636.43,368,640,370.56a28.5,28.5,0,0,0-2.2-14.18,19.07,19.07,0,0,0-10.09-9.92A14.44,14.44,0,0,0,614,348.1",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.41,348.85c0,.07-1.08.55-2.7,1.6a22.51,22.51,0,0,0-2.67,2.06,24.49,24.49,0,0,0-2.8,3A24.09,24.09,0,0,0,604,359a22.32,22.32,0,0,0-1.3,3.12c-.6,1.84-.77,3-.85,3a3.8,3.8,0,0,1,.08-.85,7.68,7.68,0,0,1,.17-1c.09-.38.17-.82.32-1.28a19.55,19.55,0,0,1,1.24-3.2,21,21,0,0,1,5.09-6.65,19.5,19.5,0,0,1,2.77-2c.41-.27.81-.46,1.15-.65a9.48,9.48,0,0,1,.9-.42A3.81,3.81,0,0,1,614.41,348.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.16,362.19a6.56,6.56,0,0,1-.68-.86c-.43-.56-1-1.36-1.85-2.32a41.3,41.3,0,0,0-7.16-6.62,25.47,25.47,0,0,0-4.59-2.74,10.71,10.71,0,0,0-4.21-1,7.62,7.62,0,0,0-2.87.49c-.65.24-1,.45-1,.42s.07-.07.22-.18a5.21,5.21,0,0,1,.72-.39,7.27,7.27,0,0,1,2.93-.63,10.7,10.7,0,0,1,4.36.9,25.2,25.2,0,0,1,4.68,2.76,36.88,36.88,0,0,1,7.14,6.77c.79,1,1.37,1.82,1.76,2.41A5.16,5.16,0,0,1,635.16,362.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.06,321.89c0,.07-1.13.76-2.87,2.06a40.63,40.63,0,0,0-6.23,5.74,41.19,41.19,0,0,0-4.89,6.92c-1.07,1.9-1.6,3.14-1.67,3.11a4.08,4.08,0,0,1,.32-.9c.22-.57.59-1.37,1.09-2.35a36.93,36.93,0,0,1,4.84-7.05,36.3,36.3,0,0,1,6.37-5.7c.9-.63,1.65-1.1,2.19-1.4A4.27,4.27,0,0,1,623.06,321.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.09,306.36a.88.88,0,0,1,.28.15c.18.11.44.27.76.5a21.47,21.47,0,0,1,2.57,2.14,24.52,24.52,0,0,1,7.43,20.07,21.66,21.66,0,0,1-.56,3.29c-.09.39-.19.68-.25.88s-.1.3-.11.29a7,7,0,0,1,.21-1.2,27.81,27.81,0,0,0,.42-3.29,25.34,25.34,0,0,0-7.34-19.84,27,27,0,0,0-2.47-2.21A8,8,0,0,1,586.09,306.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.3,336.85a2.79,2.79,0,0,1,.57-.64,10.41,10.41,0,0,1,1.88-1.41,11.42,11.42,0,0,1,14.3,2.1,9.73,9.73,0,0,1,1.4,1.89,3.19,3.19,0,0,1,.37.78,23.24,23.24,0,0,0-2-2.47,11.55,11.55,0,0,0-14-2.05A22.16,22.16,0,0,0,567.3,336.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.58,365.55a57.24,57.24,0,0,1-6.34-3,60.22,60.22,0,0,1-6.15-3.35,62.08,62.08,0,0,1,6.34,3A60.43,60.43,0,0,1,599.58,365.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.54,373.67a2.39,2.39,0,0,1,.71-.07c.45,0,1.11,0,1.92,0a29,29,0,0,1,12.15,3.44c.71.39,1.27.73,1.65,1a3.14,3.14,0,0,1,.56.43c0,.06-.9-.45-2.34-1.16a36,36,0,0,0-5.87-2.25,35.16,35.16,0,0,0-6.17-1.16C576.54,373.76,575.54,373.74,575.54,373.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.09,376.33a4.47,4.47,0,0,1-.81.56c-.54.33-1.31.83-2.25,1.47a51.29,51.29,0,0,0-6.85,5.59,52.24,52.24,0,0,0-5.76,6.71c-.66.92-1.17,1.68-1.52,2.22a5.05,5.05,0,0,1-.58.8,5.38,5.38,0,0,1,.44-.89c.31-.56.79-1.34,1.43-2.29a43.34,43.34,0,0,1,5.71-6.84,44.25,44.25,0,0,1,7-5.54c1-.61,1.76-1.08,2.33-1.37A3.89,3.89,0,0,1,623.09,376.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.69,388.24a8.11,8.11,0,0,1,1.2,0c.77,0,1.89,0,3.27.08a33.69,33.69,0,0,1,4.82.62,18.06,18.06,0,0,1,5.56,2.16,19.49,19.49,0,0,1,4.51,3.89,34.19,34.19,0,0,1,2.92,3.89c.76,1.15,1.33,2.11,1.72,2.77a5.81,5.81,0,0,1,.56,1.06,6.4,6.4,0,0,1-.69-1c-.43-.64-1-1.57-1.83-2.7a39.29,39.29,0,0,0-3-3.8,19.67,19.67,0,0,0-4.45-3.79,17.89,17.89,0,0,0-5.43-2.14,34.91,34.91,0,0,0-4.76-.7c-1.36-.11-2.48-.17-3.25-.22A6,6,0,0,1,568.69,388.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.43,417.29c0,.06-.91.06-2.37.17a34.15,34.15,0,0,0-5.64.88,34.71,34.71,0,0,0-5.4,1.82,23.49,23.49,0,0,1-2.18.95,2,2,0,0,1,.52-.37c.35-.22.88-.51,1.54-.84A27.21,27.21,0,0,1,594,417.17c.74,0,1.34,0,1.75,0A1.91,1.91,0,0,1,596.43,417.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.43,420.41c-.08.08-3.79-3.49-8.3-8s-8.09-8.19-8-8.27,3.8,3.49,8.31,8S624.51,420.33,624.43,420.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.19,404.19a19.36,19.36,0,0,0-3.29.47,18.43,18.43,0,0,0-3,1.43,5.19,5.19,0,0,1,2.88-1.82A5.35,5.35,0,0,1,609.19,404.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.38,413.46c-.06,0-.44-.73-1.22-1.85a25.12,25.12,0,0,0-3.51-4c-1.53-1.41-3-2.57-4.1-3.41a13,13,0,0,1-1.71-1.42,10.69,10.69,0,0,1,1.88,1.19,39.43,39.43,0,0,1,4.2,3.34,20.37,20.37,0,0,1,3.48,4.11,11.69,11.69,0,0,1,.78,1.44A1.9,1.9,0,0,1,603.38,413.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.83,417.08a5.55,5.55,0,0,1-2.88.48,5.47,5.47,0,0,1-2.83-.71c0-.12,1.28.25,2.85.3S601.8,417,601.83,417.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.72,390.54s-.48.82-1.21,2.13a31,31,0,0,0-2.34,5.37,30.31,30.31,0,0,0-1.24,5.72c-.18,1.49-.21,2.42-.28,2.42a1.89,1.89,0,0,1-.06-.65,17.45,17.45,0,0,1,0-1.8,24.56,24.56,0,0,1,1.15-5.82,25,25,0,0,1,2.48-5.39,17.76,17.76,0,0,1,1-1.48C607.54,390.7,607.69,390.53,607.72,390.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.38,386.07c-.06,0-.24-.58-.72-1.45a11.69,11.69,0,0,0-2.46-3,27.51,27.51,0,0,0-3.13-2.36,6.56,6.56,0,0,1-1.32-1,6.57,6.57,0,0,1,1.47.74,19.07,19.07,0,0,1,3.26,2.29,10.09,10.09,0,0,1,2.43,3.18A3.69,3.69,0,0,1,599.38,386.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.11,351.79c-.06,0-.56-.91-1.49-2.35a35.28,35.28,0,0,0-9.17-9.64c-1.39-1-2.31-1.55-2.27-1.61a3.05,3.05,0,0,1,.68.32,18.47,18.47,0,0,1,1.75,1.05,30.73,30.73,0,0,1,5.18,4.34,29.9,29.9,0,0,1,4.07,5.39,19.83,19.83,0,0,1,1,1.8A3.29,3.29,0,0,1,598.11,351.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.57,305.52a3.6,3.6,0,0,1-.47.23l-1.37.58c-1.19.51-2.92,1.23-5,2.26A30.44,30.44,0,0,0,614,313a34,34,0,0,0-6.17,7.69,95.79,95.79,0,0,0-4.57,8.8c-1.31,2.76-2.49,5.24-3.48,7.35l-2.38,4.93c-.27.55-.5,1-.67,1.33a2.8,2.8,0,0,1-.25.46,1.89,1.89,0,0,1,.18-.49l.6-1.37c.55-1.22,1.32-2.91,2.25-5s2.13-4.61,3.41-7.38a87.37,87.37,0,0,1,4.57-8.85,33.65,33.65,0,0,1,6.26-7.76,29.86,29.86,0,0,1,6.84-4.42c2.09-1,3.84-1.68,5-2.14l1.4-.52A2,2,0,0,1,627.57,305.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,290.3a6.18,6.18,0,0,1,.6,1c.38.68.88,1.68,1.45,2.93A67.68,67.68,0,0,1,607.79,315c.15,1.37.24,2.49.27,3.26a6.9,6.9,0,0,1,0,1.2,6.26,6.26,0,0,1-.17-1.19c-.08-.77-.21-1.87-.39-3.24a81.09,81.09,0,0,0-2.16-10.51,80.06,80.06,0,0,0-3.56-10.13c-.54-1.26-1-2.28-1.33-3A6.41,6.41,0,0,1,600,290.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.23,269.37a2.48,2.48,0,0,1-.23.44l-.71,1.2c-.63,1-1.57,2.52-2.66,4.39-2.22,3.72-5.19,8.93-8,14.91-1.4,3-2.62,5.9-3.62,8.58s-1.73,5.15-2.29,7.25-.88,3.81-1.1,5q-.15.84-.24,1.38a1.73,1.73,0,0,1-.11.47,2.9,2.9,0,0,1,0-.48c0-.32.07-.79.16-1.39.18-1.2.46-2.94,1-5.05a75.61,75.61,0,0,1,2.22-7.31c1-2.7,2.2-5.62,3.6-8.63a151,151,0,0,1,8.13-14.88c1.13-1.85,2.1-3.32,2.77-4.33l.78-1.16A3.92,3.92,0,0,1,626.23,269.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.48,346.19a8.55,8.55,0,0,0,5.47-6.91c.07-.61,0-1.36-.54-1.65s-1.26.12-1.74.57a10.05,10.05,0,0,0-3.09,7.38,11.62,11.62,0,0,0-1.29-6.57c-.41-.76-1.1-1.56-1.95-1.43s-1.25,1.06-1.37,1.88a6.8,6.8,0,0,0,3.94,7,6.37,6.37,0,0,0-7.26.36c-.77.62-1.41,1.75-.85,2.56a2.11,2.11,0,0,0,1.61.71,8.13,8.13,0,0,0,6.37-2.36,7.13,7.13,0,0,0-2.46,7.43,2.52,2.52,0,0,0,1.63,1.92c1.1.23,2-.8,2.54-1.8a9.35,9.35,0,0,0,0-8.07,5.33,5.33,0,0,0,4.15,2.68c1.12.09,2.51-.46,2.58-1.59s-1.1-1.79-2.13-2.11a13.19,13.19,0,0,0-5.79-.46",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M595.48,346.19a8.55,8.55,0,0,0,5.47-6.91c.07-.61,0-1.36-.54-1.65s-1.26.12-1.74.57a10.05,10.05,0,0,0-3.09,7.38,11.62,11.62,0,0,0-1.29-6.57c-.41-.76-1.1-1.56-1.95-1.43s-1.25,1.06-1.37,1.88a6.8,6.8,0,0,0,3.94,7,6.37,6.37,0,0,0-7.26.36c-.77.62-1.41,1.75-.85,2.56a2.11,2.11,0,0,0,1.61.71,8.13,8.13,0,0,0,6.37-2.36,7.13,7.13,0,0,0-2.46,7.43,2.52,2.52,0,0,0,1.63,1.92c1.1.23,2-.8,2.54-1.8a9.35,9.35,0,0,0,0-8.07,5.33,5.33,0,0,0,4.15,2.68c1.12.09,2.51-.46,2.58-1.59s-1.1-1.79-2.13-2.11a13.19,13.19,0,0,0-5.79-.46"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M598.8,341.05a30.5,30.5,0,0,0-2,2.69,28.47,28.47,0,0,0-1.43,3.06,7.11,7.11,0,0,1,1.18-3.21A7.55,7.55,0,0,1,598.8,341.05Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.87,341.17a13.34,13.34,0,0,0,.47,2.7c.49,1.43,1.22,2.46,1.14,2.51a5.75,5.75,0,0,1-1.43-2.42A4.5,4.5,0,0,1,593.87,341.17Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.53,347.93a4.9,4.9,0,0,1,2.29-1.42,4.2,4.2,0,0,1,2.68-.17,12.11,12.11,0,0,0-2.59.45C591.54,347.26,590.59,348,590.53,347.93Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.84,347.49a1.07,1.07,0,0,1-.61-1,1,1,0,0,1,.65-.95,2.91,2.91,0,0,0,.53.81,4.23,4.23,0,0,0-.57,1.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.68,354.31a4,4,0,0,1-.3-1.18,10.7,10.7,0,0,1,0-2.92,10.88,10.88,0,0,1,.76-2.83,3.57,3.57,0,0,1,.59-1.05,20.41,20.41,0,0,0-1.05,3.92A21.23,21.23,0,0,0,594.68,354.31Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.48,291.7a4.69,4.69,0,0,1,3.36,3.45c.07.33.08.74-.2.93s-.7,0-1-.21a5.53,5.53,0,0,1-2.1-3.85,6.32,6.32,0,0,1-.33,3.65c-.18.44-.51.91-1,.89s-.74-.51-.85-.95a3.7,3.7,0,0,1,1.75-4,3.48,3.48,0,0,1-4,.21c-.46-.3-.87-.88-.61-1.35a1.14,1.14,0,0,1,.84-.47,4.43,4.43,0,0,1,3.59.92,3.9,3.9,0,0,1-1.75-3.9,1.37,1.37,0,0,1,.78-1.14c.59-.19,1.16.32,1.48.84a5.11,5.11,0,0,1,.47,4.39,2.9,2.9,0,0,1,2.11-1.69c.61-.12,1.39.11,1.49.71s-.49,1-1,1.27a7.25,7.25,0,0,1-3.12.58",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M606.48,291.7a4.69,4.69,0,0,1,3.36,3.45c.07.33.08.74-.2.93s-.7,0-1-.21a5.53,5.53,0,0,1-2.1-3.85,6.32,6.32,0,0,1-.33,3.65c-.18.44-.51.91-1,.89s-.74-.51-.85-.95a3.7,3.7,0,0,1,1.75-4,3.48,3.48,0,0,1-4,.21c-.46-.3-.87-.88-.61-1.35a1.14,1.14,0,0,1,.84-.47,4.43,4.43,0,0,1,3.59.92,3.9,3.9,0,0,1-1.75-3.9,1.37,1.37,0,0,1,.78-1.14c.59-.19,1.16.32,1.48.84a5.11,5.11,0,0,1,.47,4.39,2.9,2.9,0,0,1,2.11-1.69c.61-.12,1.39.11,1.49.71s-.49,1-1,1.27a7.25,7.25,0,0,1-3.12.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M608.57,294.31a16.52,16.52,0,0,1-1.26-1.35,14.17,14.17,0,0,1-.95-1.59,4,4,0,0,0,.82,1.69A4.1,4.1,0,0,0,608.57,294.31Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.88,294.52a7.34,7.34,0,0,1,.1-1.5c.19-.8.53-1.4.48-1.43a3.2,3.2,0,0,0-.64,1.4A2.42,2.42,0,0,0,605.88,294.52Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.68,291a2.78,2.78,0,0,0,1.33.64,2.25,2.25,0,0,0,1.47-.06,6.75,6.75,0,0,1-1.44-.1C604.27,291.34,603.71,291,603.68,291Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.06,291a.59.59,0,0,0-.29.56.6.6,0,0,0,.41.48,1.77,1.77,0,0,1,.25-.47,2.22,2.22,0,0,1-.37-.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.59,287.32a1.93,1.93,0,0,0-.1.66,5.57,5.57,0,0,0,.14,1.59,6.27,6.27,0,0,0,.58,1.5,2,2,0,0,0,.38.54,11.06,11.06,0,0,1-.8-2.08A11.22,11.22,0,0,1,605.59,287.32Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.63,315.31a4.7,4.7,0,0,0-3.37,3.45.9.9,0,0,0,.2.93c.3.2.7,0,1-.21a5.46,5.46,0,0,0,2.1-3.85,6.33,6.33,0,0,0,.34,3.65c.18.44.51.92,1,.89s.73-.51.85-.95a3.72,3.72,0,0,0-1.75-4,3.48,3.48,0,0,0,4,.21c.45-.3.87-.87.6-1.35a1.14,1.14,0,0,0-.83-.47,4.45,4.45,0,0,0-3.6.92,3.88,3.88,0,0,0,1.75-3.9,1.33,1.33,0,0,0-.78-1.14c-.58-.19-1.15.32-1.48.84a5.11,5.11,0,0,0-.47,4.39A2.87,2.87,0,0,0,610,313c-.61-.11-1.4.11-1.5.72s.5,1,1,1.26a7.15,7.15,0,0,0,3.13.58",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M612.63,315.31a4.7,4.7,0,0,0-3.37,3.45.9.9,0,0,0,.2.93c.3.2.7,0,1-.21a5.46,5.46,0,0,0,2.1-3.85,6.33,6.33,0,0,0,.34,3.65c.18.44.51.92,1,.89s.73-.51.85-.95a3.72,3.72,0,0,0-1.75-4,3.48,3.48,0,0,0,4,.21c.45-.3.87-.87.6-1.35a1.14,1.14,0,0,0-.83-.47,4.45,4.45,0,0,0-3.6.92,3.88,3.88,0,0,0,1.75-3.9,1.33,1.33,0,0,0-.78-1.14c-.58-.19-1.15.32-1.48.84a5.11,5.11,0,0,0-.47,4.39A2.87,2.87,0,0,0,610,313c-.61-.11-1.4.11-1.5.72s.5,1,1,1.26a7.15,7.15,0,0,0,3.13.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M610.53,317.92a17.65,17.65,0,0,0,1.27-1.35c.61-.82.9-1.61,1-1.59a4.11,4.11,0,0,1-.82,1.69A4.17,4.17,0,0,1,610.53,317.92Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.23,318.13a9,9,0,0,0-.11-1.5c-.18-.8-.53-1.4-.48-1.43a3.07,3.07,0,0,1,.64,1.4A2.55,2.55,0,0,1,613.23,318.13Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.42,314.64a2.61,2.61,0,0,1-1.32.64,2.24,2.24,0,0,1-1.47-.06,6.65,6.65,0,0,0,1.43-.1A12.68,12.68,0,0,0,615.42,314.64Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.05,314.64a.57.57,0,0,1-.13,1,1.74,1.74,0,0,0-.24-.47,2.22,2.22,0,0,0,.37-.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.52,310.93a1.93,1.93,0,0,1,.1.66,6,6,0,0,1-.15,1.59,5.89,5.89,0,0,1-.57,1.5,2.23,2.23,0,0,1-.38.54,11.49,11.49,0,0,0,.79-2.08A10.83,10.83,0,0,0,613.52,310.93Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.37,428.37a4.68,4.68,0,0,0-3.36,3.46c-.07.33-.08.74.2.93s.69,0,1-.21a5.53,5.53,0,0,0,2.1-3.85,6.25,6.25,0,0,0,.33,3.65c.18.43.51.91,1,.89s.74-.51.85-.95a3.7,3.7,0,0,0-1.75-4,3.5,3.5,0,0,0,4,.2c.46-.29.87-.87.61-1.34a1.15,1.15,0,0,0-.84-.48,4.46,4.46,0,0,0-3.6.93,3.9,3.9,0,0,0,1.76-3.91,1.4,1.4,0,0,0-.78-1.14c-.59-.18-1.16.32-1.49.84a5.11,5.11,0,0,0-.46,4.39,2.93,2.93,0,0,0-2.11-1.69c-.61-.11-1.39.11-1.49.72s.49,1,1,1.27a7.32,7.32,0,0,0,3.13.58",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M598.37,428.37a4.68,4.68,0,0,0-3.36,3.46c-.07.33-.08.74.2.93s.69,0,1-.21a5.53,5.53,0,0,0,2.1-3.85,6.25,6.25,0,0,0,.33,3.65c.18.43.51.91,1,.89s.74-.51.85-.95a3.7,3.7,0,0,0-1.75-4,3.5,3.5,0,0,0,4,.2c.46-.29.87-.87.61-1.34a1.15,1.15,0,0,0-.84-.48,4.46,4.46,0,0,0-3.6.93,3.9,3.9,0,0,0,1.76-3.91,1.4,1.4,0,0,0-.78-1.14c-.59-.18-1.16.32-1.49.84a5.11,5.11,0,0,0-.46,4.39,2.93,2.93,0,0,0-2.11-1.69c-.61-.11-1.39.11-1.49.72s.49,1,1,1.27a7.32,7.32,0,0,0,3.13.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M596.28,431a14.73,14.73,0,0,0,1.26-1.35,15.53,15.53,0,0,0,1-1.58,4,4,0,0,1-.82,1.68A4.06,4.06,0,0,1,596.28,431Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599,431.2a7.32,7.32,0,0,0-.1-1.5c-.19-.81-.53-1.41-.48-1.43a3.33,3.33,0,0,1,.64,1.4A2.42,2.42,0,0,1,599,431.2Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.17,427.7a2.74,2.74,0,0,1-1.33.65,2.25,2.25,0,0,1-1.47-.06,6.75,6.75,0,0,0,1.44-.1A13.35,13.35,0,0,0,601.17,427.7Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.79,427.7a.57.57,0,0,1-.12,1.05,1.63,1.63,0,0,0-.25-.47,2.11,2.11,0,0,0,.37-.58",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.26,424a1.93,1.93,0,0,1,.1.66,5.3,5.3,0,0,1-.15,1.59,5.66,5.66,0,0,1-.57,1.49,1.91,1.91,0,0,1-.38.55,8.31,8.31,0,0,0,1-4.29Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.24,403.2a8.57,8.57,0,0,0-6.15,6.31c-.13.6-.14,1.35.37,1.69s1.27,0,1.79-.38a10,10,0,0,0,3.83-7,11.53,11.53,0,0,0,.62,6.67c.32.8.93,1.67,1.79,1.63s1.34-.93,1.55-1.73a6.78,6.78,0,0,0-3.2-7.38,6.36,6.36,0,0,0,7.26.38c.83-.54,1.59-1.59,1.11-2.46a2.16,2.16,0,0,0-1.53-.87,8.14,8.14,0,0,0-6.58,1.7,7.14,7.14,0,0,0,3.21-7.14,2.51,2.51,0,0,0-1.43-2.08c-1.07-.34-2.11.58-2.71,1.53a9.33,9.33,0,0,0-.85,8,5.32,5.32,0,0,0-3.85-3.08c-1.11-.21-2.55.2-2.73,1.31s.9,1.89,1.89,2.32a13.22,13.22,0,0,0,5.72,1.05",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M611.24,403.2a8.57,8.57,0,0,0-6.15,6.31c-.13.6-.14,1.35.37,1.69s1.27,0,1.79-.38a10,10,0,0,0,3.83-7,11.53,11.53,0,0,0,.62,6.67c.32.8.93,1.67,1.79,1.63s1.34-.93,1.55-1.73a6.78,6.78,0,0,0-3.2-7.38,6.36,6.36,0,0,0,7.26.38c.83-.54,1.59-1.59,1.11-2.46a2.16,2.16,0,0,0-1.53-.87,8.14,8.14,0,0,0-6.58,1.7,7.14,7.14,0,0,0,3.21-7.14,2.51,2.51,0,0,0-1.43-2.08c-1.07-.34-2.11.58-2.71,1.53a9.33,9.33,0,0,0-.85,8,5.32,5.32,0,0,0-3.85-3.08c-1.11-.21-2.55.2-2.73,1.31s.9,1.89,1.89,2.32a13.22,13.22,0,0,0,5.72,1.05"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M607.41,408a31.43,31.43,0,0,0,2.31-2.47,29.57,29.57,0,0,0,1.74-2.89,7.45,7.45,0,0,1-1.5,3.07A7.54,7.54,0,0,1,607.41,408Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.33,408.36a13.39,13.39,0,0,0-.19-2.74c-.34-1.47-1-2.57-.87-2.61a5.84,5.84,0,0,1,1.17,2.55A4.51,4.51,0,0,1,612.33,408.36Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.34,402a4.87,4.87,0,0,1-2.41,1.19,4.21,4.21,0,0,1-2.69-.12,11.81,11.81,0,0,0,2.62-.18A21.54,21.54,0,0,0,616.34,402Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612,402a1.09,1.09,0,0,1,.52,1,1.07,1.07,0,0,1-.75.87,2.9,2.9,0,0,0-.45-.85A4.33,4.33,0,0,0,612,402",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.87,395.21a3.66,3.66,0,0,1,.18,1.19,10.74,10.74,0,0,1-1.32,5.65,3.44,3.44,0,0,1-.69,1,15,15,0,0,0,1.83-7.83Z",
    style: {
      fill: "#1a2e35"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-3--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M520,460.9c-2.13-.1-2.75-3.11-2-5.09s2.36-3.73,2.38-5.86c0-1.85-1.16-3.53-1.27-5.38-.2-3.33,3-6,3.15-9.37.11-2.6-1.69-5.07-1.26-7.64.47-2.75,3.34-4.55,4-7.26.7-2.89-1.3-5.94-.54-8.81s4.14-5,3.66-7.88a25.21,25.21,0,0,0-1-2.75c-.6-2.18.59-4.46,2-6.2s3.21-3.28,4.1-5.36c1.37-3.19.42-7.08,2-10.15,1.35-2.56,4.34-4.29,4.72-7.15,1.52,2.58,0,5.86.38,8.84.22,1.93,1.23,3.68,1.84,5.54a14.42,14.42,0,0,1-1.13,11.54c-1.3,2.29-3.31,4.44-3.2,7.07.12,3.19,3.3,5.5,3.87,8.63.8,4.49-4,8.52-3.32,13,.17,1.17.71,2.26.81,3.43.34,4-4.19,6.81-4.87,10.75-.51,2.9,1.17,5.9.47,8.76-.53,2.2-2.44,4.18-2,6.4a15,15,0,0,0,1.22,2.68,5.13,5.13,0,0,1-.8,5.29,4.43,4.43,0,0,1-5.14,1.05",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.13,458.67a15,15,0,0,1-1.22-2.68c-.47-2.22,1.44-4.2,2-6.4.7-2.86-1-5.86-.47-8.76.68-3.94,5.21-6.76,4.87-10.75-.1-1.17-.64-2.26-.81-3.43-.66-4.51,4.12-8.54,3.32-13-.57-3.13-3.75-5.44-3.87-8.63-.11-2.63,1.9-4.78,3.2-7.07a14.42,14.42,0,0,0,1.13-11.54c-.61-1.86-1.62-3.61-1.84-5.54-.35-3,1.14-6.26-.38-8.84-.38,2.86-3.37,4.59-4.72,7.15-1.61,3.07-.66,7-2,10.15-.89,2.08-2.66,3.62-4.1,5.36s-2.63,4-2,6.2a25.21,25.21,0,0,1,1,2.75c.48,2.92-2.89,5-3.66,7.88s1.24,5.92.54,8.81c-.66,2.71-3.53,4.51-4,7.26-.43,2.57,1.37,5,1.26,7.64-.13,3.33-3.35,6-3.15,9.37.11,1.85,1.29,3.53,1.27,5.38,0,2.13-1.59,3.89-2.38,5.86s-.17,5,2,5.09l8.19,4.11a4.43,4.43,0,0,0,5.14-1.05A5.13,5.13,0,0,0,534.13,458.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M531.35,456.72a5.85,5.85,0,0,1-.82-3.15c.22-1.21,2.28-2.28,2.79-4.35.67-2.68-.53-7.42,0-10.13.69-3.67,4.49-6.09,4.34-9.74,0-1.07.1-3.94,0-5-.41-4.11,3.2-6.87,2.68-11-.37-2.85-3.33-6.19-3.33-9.11,0-2.42,1.73-4.53,2.88-6.72a15.13,15.13,0,0,0,1.3-10.71,26.37,26.37,0,0,1-1.36-5c-.19-2.71,1.14-5.84,0-8.11-.41,2.66-2.94,4.44-4.14,6.89-1.43,2.93-.77,6.45-2,9.48-.8,2-2.31,3.51-3.56,5.2s-2.31,3.87-1.88,5.84a23.44,23.44,0,0,1,.75,2.47c.3,2.65-2.56,4.81-3.28,7.49s.84,5.37.17,8.07c-.63,2.54-3.12,6-3.59,8.56-.45,2.38,1.72,3.94,1.55,6.34-.22,3.07-3.3,6.8-3.24,9.85,0,1.69,1.45,2.23,1.38,3.94-.09,2-1.73,5.86-2.45,7.73a5.31,5.31,0,0,0,.51,5.27l9.15,4.54C533.23,463.49,533.05,459.52,531.35,456.72Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.5,387.67a.85.85,0,0,1,0,.21v.59c0,.52,0,1.3-.09,2.29a11.52,11.52,0,0,1-.83,3.53,18.26,18.26,0,0,1-2.75,3.92,7.19,7.19,0,0,0-1.3,2.39,8.28,8.28,0,0,0-.34,2.93c.1,2.07.74,4.22,1,6.56a10,10,0,0,1-.12,3.64,7.22,7.22,0,0,1-.71,1.76,16,16,0,0,0-1,1.61,5.94,5.94,0,0,0-.05,3.71c.13.64.27,1.3.35,2a7.91,7.91,0,0,1,0,2.06,16.47,16.47,0,0,1-1.26,3.84,31.5,31.5,0,0,0-1.41,3.6,9.24,9.24,0,0,0-.32,3.65,17,17,0,0,1,.13,3.63,11.07,11.07,0,0,1-1.16,3.26,13,13,0,0,0-1.15,3c-.39,2,.19,4,.14,5.75a15.29,15.29,0,0,1-1,4.69,16.88,16.88,0,0,0-.89,3.47,5,5,0,0,0,.23,2.23c.19.48.33.72.31.73a3.56,3.56,0,0,1-.38-.71,4.82,4.82,0,0,1-.3-2.26,16,16,0,0,1,.84-3.53,15.35,15.35,0,0,0,1-4.62,24.93,24.93,0,0,0-.22-2.76,10.43,10.43,0,0,1,0-3.05c.4-2.12,1.95-3.93,2.27-6.22a16.48,16.48,0,0,0-.14-3.55,9.55,9.55,0,0,1,.32-3.78c.7-2.5,2.22-4.76,2.66-7.4a7.58,7.58,0,0,0,0-2c-.08-.65-.22-1.3-.35-1.94a6.39,6.39,0,0,1,.08-3.94,18.25,18.25,0,0,1,1-1.64,6.38,6.38,0,0,0,.68-1.67,9.44,9.44,0,0,0,.12-3.51c-.28-2.3-.91-4.47-1-6.59a8.36,8.36,0,0,1,.37-3,7.34,7.34,0,0,1,1.36-2.46,18.81,18.81,0,0,0,2.77-3.85,11.77,11.77,0,0,0,.88-3.47c.11-1,.13-1.75.16-2.27l0-.59A.85.85,0,0,1,537.5,387.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.93,462c-3,.43-4.66-3.56-4.11-6.52s2.25-5.82,1.69-8.78c-.48-2.56-2.56-4.57-3.22-7.09-1.2-4.56,2.52-9.2,1.79-13.86-.56-3.62-3.73-6.56-3.83-10.23-.11-3.94,3.37-7.23,3.54-11.16.18-4.19-3.43-7.87-3.15-12.06s4.37-8,2.9-11.91c-.48-1.3-1.52-2.31-2.14-3.55-1.43-2.85-.41-6.32,1.11-9.13s3.55-5.43,4.21-8.55c1-4.8-1.36-9.93,0-14.63,1.16-3.91,4.83-7.12,4.57-11.19,2.81,3.15,1.65,8.11,2.95,12.14.84,2.62,2.71,4.77,4.07,7.17a20.38,20.38,0,0,1,1.6,16.3c-1.18,3.53-3.37,7.06-2.51,10.68,1,4.38,6.09,6.7,7.73,10.89,2.34,6-3.17,12.9-1,19,.55,1.56,1.59,2.93,2.05,4.53,1.56,5.43-3.93,10.57-3.8,16.22.09,4.16,3.23,7.85,3.06,12-.14,3.21-2.24,6.47-1,9.42A21.32,21.32,0,0,0,525.9,455a7.22,7.22,0,0,1,.34,7.54,6.28,6.28,0,0,1-6.83,2.87",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.9,455a21.32,21.32,0,0,1-2.42-3.38c-1.26-2.95.84-6.21,1-9.42.17-4.15-3-7.84-3.06-12-.13-5.65,5.36-10.79,3.8-16.22-.46-1.6-1.5-3-2.05-4.53-2.15-6.07,3.36-13,1-19-1.64-4.19-6.68-6.51-7.73-10.89-.86-3.62,1.33-7.15,2.51-10.68a20.38,20.38,0,0,0-1.6-16.3c-1.36-2.4-3.23-4.55-4.07-7.17-1.3-4-.14-9-2.95-12.14.26,4.07-3.41,7.28-4.57,11.19-1.4,4.7,1,9.83,0,14.63-.66,3.12-2.69,5.74-4.21,8.55s-2.54,6.28-1.11,9.13c.62,1.24,1.66,2.25,2.14,3.55,1.47,3.91-2.62,7.74-2.9,11.91s3.33,7.87,3.15,12.06c-.17,3.93-3.65,7.22-3.54,11.16.1,3.67,3.27,6.61,3.83,10.23.73,4.66-3,9.3-1.79,13.86.66,2.52,2.74,4.53,3.22,7.09.56,3-1.13,5.83-1.69,8.78s1.14,6.95,4.11,6.52l12.48,3.45a6.28,6.28,0,0,0,6.83-2.87A7.22,7.22,0,0,0,525.9,455Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M521.52,453.05a8.24,8.24,0,0,1-2-4.14c0-1.75,2.53-3.8,2.67-6.8.19-3.89-2.77-10.14-2.81-14,0-5.28,4.56-9.67,3.35-14.69-.36-1.47-.93-5.48-1.37-6.92-1.69-5.59,2.56-10.4.71-15.9-1.29-3.85-6.3-7.67-7.1-11.72-.67-3.35,1.15-6.76,2.14-10.11A21.22,21.22,0,0,0,516,353.57c-1.08-2.18-2.58-4.11-3.24-6.53-1-3.71,0-8.4-2.27-11.23.17,3.8-2.85,7-3.84,10.67-1.18,4.47.7,9.15-.18,13.69-.57,2.95-2.25,5.49-3.51,8.19s-2.14,6-1,8.59a35.39,35.39,0,0,1,1.71,3.22c1.15,3.6-2.22,7.36-2.49,11.28s2.63,7.21,2.44,11.14c-.17,3.69-2.67,9.15-2.63,12.83,0,3.43,3.47,5,3.89,8.36.54,4.32-2.71,10.33-1.79,14.54.51,2.33,2.62,2.7,3,5.08.42,2.74-.78,8.6-1.27,11.39a7.5,7.5,0,0,0,2.15,7.16l13.92,3.78C526,461.91,524.63,456.46,521.52,453.05Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.12,355.7a35.47,35.47,0,0,1,.72,4.29,16.18,16.18,0,0,1-.19,5.11,13.05,13.05,0,0,1-1.09,3c-.5,1-1.11,2.05-1.66,3.17a10.38,10.38,0,0,0-1.16,3.68,11.47,11.47,0,0,0,.34,4.17c.7,2.84,2.17,5.65,3.23,8.81a14.35,14.35,0,0,1,.83,5.05,10,10,0,0,1-.51,2.62,21.36,21.36,0,0,0-.9,2.5c-.42,1.72.23,3.51.94,5.2.36.86.74,1.72,1,2.63a10.51,10.51,0,0,1,.49,2.85,23,23,0,0,1-.69,5.65,43.52,43.52,0,0,0-1,5.38,12.93,12.93,0,0,0,0,2.64,14.53,14.53,0,0,0,.54,2.54,23,23,0,0,1,1.17,5,15.24,15.24,0,0,1-.7,4.82,18.75,18.75,0,0,0-.78,4.45,14.37,14.37,0,0,0,.74,4.13,38.22,38.22,0,0,1,1.05,3.8,13.76,13.76,0,0,1,.17,3.59c-.07,1.13-.21,2.19-.34,3.18a23.14,23.14,0,0,0-.27,5.06,6.9,6.9,0,0,0,1,3c.39.62.66.9.64.92a5.47,5.47,0,0,1-.7-.88,6.85,6.85,0,0,1-1-3.05,23.07,23.07,0,0,1,.21-5.11c.12-1,.24-2,.31-3.16a13.76,13.76,0,0,0-.2-3.53,36.7,36.7,0,0,0-1.06-3.77,14.69,14.69,0,0,1-.77-4.22,17.92,17.92,0,0,1,.77-4.52,15.19,15.19,0,0,0,.68-4.72,23.54,23.54,0,0,0-1.17-4.9,14.53,14.53,0,0,1-.56-2.59,13.62,13.62,0,0,1,0-2.71,43.29,43.29,0,0,1,1-5.43,22.52,22.52,0,0,0,.68-5.56,10.3,10.3,0,0,0-.47-2.75c-.28-.88-.65-1.74-1-2.6a16.51,16.51,0,0,1-.92-2.64,6.21,6.21,0,0,1,0-2.78,21.12,21.12,0,0,1,.92-2.54,9.61,9.61,0,0,0,.49-2.52,13.81,13.81,0,0,0-.8-4.92c-1-3.13-2.5-5.95-3.2-8.85a11.55,11.55,0,0,1-.33-4.27,10.71,10.71,0,0,1,1.21-3.77c.57-1.12,1.18-2.15,1.68-3.15a12.41,12.41,0,0,0,1.1-2.95,16.3,16.3,0,0,0,.25-5.05c-.12-1.4-.31-2.47-.42-3.2l-.12-.83C511.13,355.8,511.12,355.7,511.12,355.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.07,463.91c-1.7.83-3.48-1.23-3.72-3.11s.22-3.92-.68-5.58c-.79-1.44-2.42-2.24-3.31-3.62-1.59-2.5-.27-6-1.6-8.64-1-2.06-3.5-3.21-4.27-5.38-.83-2.34.62-5,0-7.37s-3.57-4-4.22-6.61,1.07-5.63-.56-7.69a22.88,22.88,0,0,0-2-1.7c-1.41-1.44-1.47-3.71-1.1-5.69s1.07-3.93.87-5.93c-.32-3.07-2.74-5.67-2.81-8.76-.06-2.57,1.52-5.2.57-7.58,2.3,1.34,2.56,4.53,4.12,6.69,1,1.41,2.54,2.34,3.82,3.51a12.79,12.79,0,0,1,4.1,9.45c0,2.33-.64,4.87.57,6.87,1.47,2.42,4.94,2.84,6.73,5,2.56,3.13.59,8.33,3.06,11.54.63.83,1.52,1.45,2.1,2.32,2,2.95-.31,7.09.86,10.44.86,2.47,3.45,4.08,4.15,6.6.54,1.94-.09,4.3,1.23,5.82a13.48,13.48,0,0,0,2.11,1.55,4.55,4.55,0,0,1,1.66,4.45,4,4,0,0,1-3.54,3",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.08,456.07a13.48,13.48,0,0,1-2.11-1.55c-1.32-1.52-.69-3.88-1.23-5.82-.7-2.52-3.29-4.13-4.15-6.6-1.17-3.35,1.12-7.49-.86-10.44-.58-.87-1.47-1.49-2.1-2.32-2.47-3.21-.5-8.41-3.06-11.54-1.79-2.19-5.26-2.61-6.73-5-1.21-2-.59-4.54-.57-6.87a12.79,12.79,0,0,0-4.1-9.45c-1.28-1.17-2.81-2.1-3.82-3.51-1.56-2.16-1.82-5.35-4.12-6.69.95,2.38-.63,5-.57,7.58.07,3.09,2.49,5.69,2.81,8.76.2,2-.5,4-.87,5.93s-.31,4.25,1.1,5.69a22.88,22.88,0,0,1,2,1.7c1.63,2.06-.08,5.14.56,7.69s3.52,4.07,4.22,6.61-.79,5,0,7.37c.77,2.17,3.23,3.32,4.27,5.38,1.33,2.64,0,6.14,1.6,8.64.89,1.38,2.52,2.18,3.31,3.62.9,1.66.44,3.71.68,5.58s2,3.94,3.72,3.11l8.13-.35a4,4,0,0,0,3.54-3A4.55,4.55,0,0,0,515.08,456.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M512.08,455.76a5.29,5.29,0,0,1-2-2.09c-.35-1,.78-2.76.29-4.58-.64-2.37-3.62-5.54-4.39-7.85-1.05-3.16.86-6.67-.84-9.44-.5-.81-1.62-3.1-2.16-3.88-2.09-3-.48-6.72-2.65-9.66-1.51-2.05-5.25-3.37-6.51-5.64-1.05-1.87-.62-4.26-.67-6.46a13.43,13.43,0,0,0-3.61-8.87,22.57,22.57,0,0,1-3.2-3.28c-1.33-2-1.64-5-3.53-6.28.83,2.24-.37,4.72-.24,7.13.15,2.9,2.19,5.34,2.54,8.23a22.29,22.29,0,0,1-.52,5.57c-.24,1.86-.12,4,1.06,5.34a20.77,20.77,0,0,1,1.65,1.6c1.38,1.93.09,4.83.69,7.23s3,3.81,3.62,6.2.16,6,.9,8.18,3,2.32,3.94,4.26c1.16,2.48.37,6.7,1.74,9,.76,1.3,2.09,1.11,2.77,2.46.78,1.57,1.19,5.3,1.44,7.07a4.72,4.72,0,0,0,2.67,3.87l9.06-.43C516.46,460.21,514.6,457.2,512.08,455.76Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,399.51s0,.05.1.15l.27.46c.22.4.55,1,.91,1.81a10,10,0,0,1,.89,3.1,15.93,15.93,0,0,1-.44,4.24,6.52,6.52,0,0,0,0,2.41,7.09,7.09,0,0,0,1,2.41c1,1.56,2.39,3,3.64,4.64a9,9,0,0,1,1.48,2.88,6,6,0,0,1,.2,1.69,13.32,13.32,0,0,0-.05,1.66,5.24,5.24,0,0,0,1.56,2.89c.37.44.77.89,1.12,1.38a7,7,0,0,1,.85,1.63,14.14,14.14,0,0,1,.69,3.53,26.29,26.29,0,0,0,.45,3.4,8.32,8.32,0,0,0,1.33,3,14.7,14.7,0,0,1,1.67,2.76,9.94,9.94,0,0,1,.51,3,11.4,11.4,0,0,0,.39,2.8c.56,1.73,1.84,3,2.59,4.4a13.8,13.8,0,0,1,1.2,4.09,15.08,15.08,0,0,0,.8,3.09,4.64,4.64,0,0,0,1.14,1.63c.35.29.56.41.55.43a3.82,3.82,0,0,1-.6-.38A4.41,4.41,0,0,1,508.1,461a14.42,14.42,0,0,1-.87-3.1,13.86,13.86,0,0,0-1.23-4c-.73-1.36-2-2.6-2.65-4.43s-.19-3.9-.93-5.8a14.23,14.23,0,0,0-1.64-2.7,8.46,8.46,0,0,1-1.39-3.08c-.53-2.24-.33-4.65-1.13-6.88a6.12,6.12,0,0,0-.81-1.54c-.33-.48-.72-.91-1.1-1.36a5.59,5.59,0,0,1-1.64-3.1,13.39,13.39,0,0,1,.06-1.7,5.63,5.63,0,0,0-.19-1.59,8.56,8.56,0,0,0-1.42-2.77c-1.21-1.66-2.64-3.08-3.62-4.68a7.5,7.5,0,0,1-1-2.52,6.77,6.77,0,0,1,0-2.5,16.4,16.4,0,0,0,.49-4.18,10.23,10.23,0,0,0-.82-3.06c-.33-.81-.65-1.42-.85-1.84l-.23-.48A1.37,1.37,0,0,1,487,399.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.06 456.74 495.59 463.9 538.51 463.9 543.35 456.74 492.06 456.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.62 461.44 503.04 483.62 531.95 483.64 537.77 461.48 496.62 461.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.32,463.85c0,.1-9.58.19-21.39.19s-21.39-.09-21.39-.19,9.57-.18,21.39-.18S538.32,463.75,538.32,463.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.26,441.3s-17.37-20-15.44-20.74,17.37,10.37,17.37,10.37-13.27-29.66-10.61-31.83,16.64,26.29,16.64,26.29-2.17-41.49,0-42,10.13,41.48,10.13,41.48,11.82-38.34,15.19-38.34-3.61,36.9-3.61,36.9,14-23.64,16.16-20.5-9.89,28.7-9.89,28.7,17.6-14.72,18.33-12.79-19.06,22.43-19.06,22.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.84,411.16c.12-.06,3.2,6.55,6.88,14.74s6.56,14.89,6.44,15-3.2-6.55-6.88-14.75S421.72,411.21,421.84,411.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.87,414.85c.13,0,.64,5.81,1.14,13s.8,13,.67,13-.65-5.81-1.15-13S435.73,414.85,435.87,414.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.22,396.27a2.18,2.18,0,0,1-.11.47c-.1.35-.22.79-.38,1.32-.36,1.21-.85,2.84-1.45,4.83-1.22,4.08-2.87,9.73-4.55,16s-3.06,12-4,16.15c-.47,2-.86,3.68-1.15,4.91-.13.54-.24,1-.33,1.33a1.62,1.62,0,0,1-.14.46,1.53,1.53,0,0,1,.05-.47c.06-.37.14-.81.24-1.36.22-1.17.56-2.86,1-4.95.89-4.17,2.23-9.91,3.9-16.19s3.38-11.93,4.69-16c.65-2,1.2-3.67,1.6-4.79.18-.52.34-.95.46-1.29S455.2,396.26,455.22,396.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.58,417.65c.11.08-3.28,5.13-7.57,11.29s-7.85,11.09-8,11,3.28-5.12,7.57-11.28S463.48,417.58,463.58,417.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.12,440.88a6.4,6.4,0,0,1-1.52-1.08,42.47,42.47,0,0,1-3.3-3.06,41.88,41.88,0,0,1-3-3.38,6.65,6.65,0,0,1-1.05-1.54c.11-.09,1.92,2.1,4.36,4.59S430.21,440.77,430.12,440.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.67,432.93a37.73,37.73,0,0,1,.76,8.3,17.83,17.83,0,0,1-.62-4.13A18.37,18.37,0,0,1,440.67,432.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.1,400.39a12.42,12.42,0,0,1,.12,1.66c0,1.15.08,2.68.14,4.54.11,3.82.21,9.11.3,15s.15,11.14.16,15c0,1.85,0,3.38,0,4.53a10.87,10.87,0,0,1-.07,1.66,10.41,10.41,0,0,1-.12-1.66c0-1.15-.09-2.68-.15-4.53-.1-3.83-.21-9.12-.3-15s-.14-11.14-.15-15c0-1.85,0-3.38,0-4.53A9.43,9.43,0,0,1,441.1,400.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.55,397.19a7.38,7.38,0,1,1-7.94-6.77A7.39,7.39,0,0,1,448.55,397.19Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.89,405.18A14.51,14.51,0,0,1,441,403a12.15,12.15,0,0,0-.76-5,6.81,6.81,0,0,0-3.33-3.57,10.23,10.23,0,0,0-2-.57s.21-.07.59-.07a4.21,4.21,0,0,1,1.57.32,6.74,6.74,0,0,1,3.65,3.7,11,11,0,0,1,.65,5.17A7.4,7.4,0,0,1,440.89,405.18Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M447.77,394.89a10.93,10.93,0,0,0-4.1,1.33,10.73,10.73,0,0,0-2.88,3.19c-.06,0,0-.53.43-1.25a6.41,6.41,0,0,1,2.19-2.35,6.59,6.59,0,0,1,3-1A2.42,2.42,0,0,1,447.77,394.89Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M444.47,395.48c-.08,0-.18-.49-.64-1.11a3.5,3.5,0,0,0-2.48-1.46,3.59,3.59,0,0,0-2.69,1c-.55.55-.73,1-.81,1s0-.56.56-1.23a3.52,3.52,0,0,1,3-1.28,3.6,3.6,0,0,1,2.74,1.76C444.55,394.93,444.52,395.48,444.47,395.48Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M442.43,396.9c-.14,0-.3-1-.92-2.06s-1.4-1.71-1.32-1.83,1.07.4,1.75,1.58A2.94,2.94,0,0,1,442.43,396.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M441.71,394.7c0,.14-.57.34-1.08.83s-.85,1.06-1,1,0-.72.64-1.34S441.71,394.58,441.71,394.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M460,429.45a10.14,10.14,0,0,1-.58,1.95c-.49,1.37-1,2.92-1.63,4.63s-1.17,3.24-1.67,4.61a8.59,8.59,0,0,1-.78,1.88A66.62,66.62,0,0,1,460,429.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.8,426.06a6.32,6.32,0,1,1-4.87-7.49A6.32,6.32,0,0,1,467.8,426.06Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M459.57,430.74a9.79,9.79,0,0,1,.55-1.74,10.64,10.64,0,0,0,.57-4.25,5.93,5.93,0,0,0-1.84-3.73,11.26,11.26,0,0,0-1.5-1,2.76,2.76,0,0,1,1.72.71,5.76,5.76,0,0,1,2.11,3.94,9.29,9.29,0,0,1-.74,4.42A5.34,5.34,0,0,1,459.57,430.74Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M467.72,424a7.34,7.34,0,0,0-6.83,2c-.05,0,.14-.44.64-.95a5.6,5.6,0,0,1,5.14-1.51C467.36,423.69,467.74,423.92,467.72,424Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M464.87,423.66c-.08,0-.05-.45-.27-1.06a3.07,3.07,0,0,0-1.68-1.78,3,3,0,0,0-2.43.18c-.58.3-.85.64-.92.59s.13-.47.74-.89a3,3,0,0,1,4.62,1.8C465.09,423.22,464.92,423.67,464.87,423.66Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M462.85,424.32c-.14,0,0-.89-.29-1.9s-.71-1.74-.6-1.83.81.57,1.08,1.71S463,424.37,462.85,424.32Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M462.8,422.35c0,.14-.55.17-1.08.45s-1,.64-1.06.53.18-.6.84-1S462.82,422.23,462.8,422.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M432.31,416.31a4.15,4.15,0,0,1,.25,1.05l.48,2.88c.39,2.43.89,5.79,1.42,9.51s1,7.09,1.27,9.53l.33,2.9a3.78,3.78,0,0,1,.05,1.07,4.32,4.32,0,0,1-.24-1c-.13-.79-.29-1.75-.49-2.88-.38-2.43-.89-5.8-1.41-9.52s-1-7.1-1.27-9.54l-.33-2.9A4.71,4.71,0,0,1,432.31,416.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.68,409.67a6.31,6.31,0,1,1-7.79-4.38A6.32,6.32,0,0,1,437.68,409.67Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M432.57,417.64a9.88,9.88,0,0,1-.33-1.8,10.34,10.34,0,0,0-1.46-4,5.91,5.91,0,0,0-3.36-2.45,11.44,11.44,0,0,0-1.78-.16,2.67,2.67,0,0,1,1.85-.18,5.81,5.81,0,0,1,3.7,2.52,9.34,9.34,0,0,1,1.4,4.25A5.26,5.26,0,0,1,432.57,417.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M436.65,407.86a10.49,10.49,0,0,0-3.2,1.82,10.21,10.21,0,0,0-1.92,3.13c-.06,0-.07-.45.13-1.13a5.55,5.55,0,0,1,1.45-2.35,5.48,5.48,0,0,1,2.4-1.37C436.2,407.78,436.64,407.8,436.65,407.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M434,408.9c-.07,0-.24-.37-.73-.81a2.84,2.84,0,0,0-4.38.49c-.38.54-.45,1-.53.95s-.11-.47.24-1.14a3,3,0,0,1,4.92-.54C434,408.42,434,408.89,434,408.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M432.5,410.43c-.14,0-.45-.78-1.14-1.55s-1.44-1.21-1.39-1.34,1,.13,1.76,1S432.63,410.41,432.5,410.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M431.53,408.7c.06.14-.41.41-.74.9s-.55,1-.69,1-.13-.62.29-1.25S431.5,408.58,431.53,408.7Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "421.07 448.18 426.38 483.07 457.23 483.07 464.39 448.69 421.07 448.18",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.07,470.54c0,.1-7.9.18-17.65.18s-17.65-.08-17.65-.18,7.9-.18,17.65-.18S460.07,470.44,460.07,470.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.19,468.83c0,.1-7.95.18-17.77.18s-17.77-.08-17.77-.18,8-.18,17.77-.18S460.19,468.73,460.19,468.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.13,466.89c0,.1-7.95.18-17.77.18s-17.77-.08-17.77-.18,8-.18,17.77-.18S460.13,466.79,460.13,466.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.93,481.08a26.94,26.94,0,0,1-.95-4.39,28.48,28.48,0,0,1-.59-4.46,28.57,28.57,0,0,1,.95,4.4A29.79,29.79,0,0,1,429.93,481.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,480.71a34.41,34.41,0,0,1-.38-4.29,34,34,0,0,1-.2-4.29,20.31,20.31,0,0,1,.56,4.27A19.88,19.88,0,0,1,432,480.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.85,480.71a20.78,20.78,0,0,1-.8-4.4,21.43,21.43,0,0,1-.24-4.46,123.43,123.43,0,0,1,1,8.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.53,480.89a21.93,21.93,0,0,1-.42-4.46,21.39,21.39,0,0,1,.13-4.49,35.77,35.77,0,0,1,.23,4.48A35.27,35.27,0,0,1,438.53,480.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.29,480.71a48.84,48.84,0,0,1-.29-8.49,51.61,51.61,0,0,1,.29,8.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.76,480.89a51.95,51.95,0,0,1,.07-8.76,54.91,54.91,0,0,1-.07,8.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,480.43a29.56,29.56,0,0,1,.26-4.58,29.22,29.22,0,0,1,.63-4.55,60,60,0,0,1-.89,9.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.21,480a15.07,15.07,0,0,1,.52-3.9,16.09,16.09,0,0,1,1.14-3.76,32.93,32.93,0,0,1-.79,3.84A34.83,34.83,0,0,1,454.21,480Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.53,441.27v6.53a2.57,2.57,0,0,0,2.57,2.57h44.67a2.57,2.57,0,0,0,2.57-2.57v-6.53Z",
    style: {
      fill: "#137D46"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "421.41 450.37 421.78 452.45 462.99 455.39 464.04 450.37 421.41 450.37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlants);
export default __webpack_public_path__ + "static/media/plants.1ecf45063faf9a42e66c4b946db911ad.svg";
export { ForwardRef as ReactComponent };